// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__5e6wR","txtWrapper":"styles_txtWrapper__mFNJ4","linkWrapper":"styles_linkWrapper__nIj91","linkTxt":"styles_linkTxt__7z2uj","arrow":"styles_arrow__MXhMT"};